var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-1 mx-auto ma-1 rounded-xl",attrs:{"max-width":"800","outlined":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }